// Styles
import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";

const accountSettingsStyles = makeStyles((theme: Theme) => ({
    main: {
        padding: theme.spacing(2),
    },
    row: {
        marginBottom: theme.spacing(8),
    },
    rowTitle: {
        marginBottom: theme.spacing(1),
        fontWeight: 600,
    },
    rowDetails: {
        display: "flex",
        alignItems: "center",
    },
    text: {
        fontSize: theme.typography.pxToRem(16),
    },
    textField: {
        marginLeft: theme.spacing(1),
        width: 240,
    },
    passwordField: {
        width: "100%",
        "& input::-ms-reveal": {
            display: "none",
        },
    },
    passwordGrid: {
        alignItems: "start",
        marginBottom: theme.spacing(1),
        width: "80%",
        "& $absoluteHelper": {
            "& .MuiFormHelperText-root.Mui-error": {
                position: "relative !important",
            },
        },
    },
    passwordTitle: {
        marginBottom: theme.spacing(1),
    },
    deleteAction: {
        color: theme.palette.error.main,
        textDecoration: "underline",
        textUnderlineOffset: "4px",
        padding: 0,
    },
    absoluteHelper: {
        "& .MuiFormHelperText-root.Mui-error": {
            position: "absolute",
            top: "100%",
        },
    },
    textBtn: {
        textDecoration: "underline",
        color: theme.palette.secondary.main,
        textUnderlineOffset: "4px",
        padding: 0,
    },
    passwordValidationBox: {
        backgroundColor: theme.palette.background.grey,
        marginTop: theme.spacing(1),
        padding: theme.spacing(1),
        borderRadius: theme.spacing(1),
    },
    passwordValidationList: {
        padding: 0,
        margin: theme.spacing(0.5, 0, 0, 0),
        listStyle: "none",
        "& > li": {
            display: "flex",
            alignItems: "center",
            marginBottom: theme.spacing(0.25),
        },
        "& .MuiSvgIcon-root": {
            fontSize: 18,
            marginRight: theme.spacing(0.5),
        },
    },
    invalidOption: {
        fontWeight: 700,
    },
}));

export default accountSettingsStyles;
